<template>
    <div class="index">
        <h1>欢迎使用本系统</h1>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'Home',
});
</script>
